import { createFileRoute } from "@tanstack/react-router";
import SpravatoFitsYourSchedule from "@/pages/SpravatoFitsYourSchedule";
export const Route = createFileRoute("/spravato-fits-your-schedule")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Spravato Fits Your Schedule | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "SPRAVATO sessions fit into your schedule. Learn about treatment frequency, session length, and planning in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:title",
          content: "Spravato Fits Your Schedule | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "SPRAVATO sessions fit into your schedule. Learn about treatment frequency, session length, and planning in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/spravato-fits-your-schedule",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/spravato-fits-your-schedule",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <SpravatoFitsYourSchedule />;
}
